/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_SimulateInputs */

const en_billing_simulate = /** @type {(inputs: Billing_SimulateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulate payment (dev)`)
};

const id_billing_simulate = /** @type {(inputs: Billing_SimulateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulasikan pembayaran (dev)`)
};

/**
* | output |
* | --- |
* | "Simulate payment (dev)" |
*
* @param {Billing_SimulateInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_simulate = /** @type {((inputs?: Billing_SimulateInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_SimulateInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_simulate(inputs)
	return en_billing_simulate(inputs)
});